<template>
  <div
    v-if="categories.length"
    class="border-t border-gray-300"
  >
    <div
      class="xl:px-9 lg:px-[34px] sm:px-[22px] px-[18px] my-4 max-w-screen-xl mx-auto w-full flex flex-col justify-start py-6"
    >
      <div class="uppercase lg:capitalize font-bold">Категории</div>
      <div class="mt-8 flex gap-x-3 md:gap-x-5 gap-y-6 flex-wrap">
        <nuxt-link
          v-for="item in categoriesWithSlug"
          :key="item.slug"
          class="bg-gray-300 rounded-full text-gray-800 text-sm font-bold px-3 py-1 block whitespace-nowrap hover:bg-gray-400"
          :to="$localePath(`/${city.slug}/catalog/${item.slug}`)"
        >
          {{ item.name }}
        </nuxt-link>
        <span
          v-for="item in categoriesWithoutSlug"
          :key="item.name"
          class="bg-gray-300 rounded-full text-gray-800 text-sm font-bold px-3 py-1 block whitespace-nowrap"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup () {
    const { city } = useSearchForm()
    return {
      city,
    }
  },
  computed: {
    categories () {
      return this.city?.rootNotEmptyCategories || []
    },
    categoriesWithSlug () {
      return this.categories.filter(item => item.slug)
    },
    categoriesWithoutSlug () {
      return this.categories.filter(item => !item.slug)
    },
  },
}
</script>
